import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-5.0.7274",
  buildId: "5.0.7274",
  name: "Official Release",
  season: 0,
  type: "patch",
  officialUrl: "https://www.ageofempires.com/news/age-of-empires-iv-is-available-now",
  summary: "",
  introduction: `
![](https://www.ageofempires.com/wp-content/uploads/2021/08/AoE4_KeyArt_1920x1080-1080x608.jpg)
""`,
  date: new Date("2021-10-16T19:12:38Z"),
  sections: [

  ],
};
